import cx from 'classnames';
import React from 'react';
import { Button, TextArea } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
const messages = defineMessages({
  insertTitle: {
    id: 'insertTitle',
    defaultMessage: 'Insert title...',
  },
});

export default (props) => {
  const { handleTitleChange, handleTitleClick, uid, panel, active } = props;
  const intl = useIntl();

  return (
    <Button
      className={cx('tab-title', {
        active: active,
      })}
      type="button"
      onClick={handleTitleClick}
    >
      <TextArea
        fluid
        className="input-tab-title"
        transparent
        placeholder={intl.formatMessage(messages.insertTitle)}
        value={panel?.title || ''}
        onClick={(e) => {
          handleTitleClick();
          e.stopPropagation();
        }}
        rows="2"
        onChange={(e) => handleTitleChange(e, [uid, panel])}
      />
    </Button>
  );
};
